/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as amplitude from '@amplitude/analytics-browser';
import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

/**
 * TODO: Research needed if amplitude instance follows the singleton pattern.
 * If it does, we can use the same instance across the app.
 * If not, instead of creating a new instance every time use this zustand store.
 */
const ampIdentify = new amplitude.Identify();

export const ampStore = createStore(() => ({
  ampIdentify,
  identify: () => amplitude.identify(ampIdentify), // shortcut to identify
}));
/**
 * React hook version of ampStore
 */
export const useAmpStore = () => useStore(ampStore);
